import { MapTo } from '@adobe/aem-react-editable-components';
import ProductCardCompare, { ProductCardCompareEditConfig } from './ProductCardCompare';

export default MapTo('cob-corp-acquisition/components/creditonebank/product-card-compare')(ProductCardCompare, ProductCardCompareEditConfig);